var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17257_545)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D1D5DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3739 8.72943C19.8843 10.4932 18.5348 12.4366 16.988 12.8872C15.4412 13.3379 13.3279 12.4032 12.8175 10.6395C12.3071 8.8758 13.3785 6.43205 14.9254 5.98141C16.988 5.38051 18.8636 6.96571 19.3739 8.72943Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2247 8.72943C19.7143 10.4932 21.0638 12.4366 22.6106 12.8872C24.1575 13.3379 26.2708 12.4032 26.7811 10.6395C27.2915 8.8758 26.2201 6.43205 24.6732 5.98141C22.6106 5.38051 20.7351 6.96571 20.2247 8.72943Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8014 21.6148C29.8014 26.1009 25.4026 27.7684 19.4024 27.7684C13.4023 27.7684 9.10303 26.1009 9.10303 21.6148C9.10303 16.3965 13.4023 11.769 19.4024 11.769C25.4026 11.769 29.8014 16.0027 29.8014 21.6148Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4166 20.7286C17.4166 22.1979 16.4736 23.8097 15.1557 23.8097C13.8379 23.8097 11.709 22.6125 11.709 20.4178C11.709 18.3561 14.0088 17.6228 16.3853 17.9993C17.8418 18.2301 17.4166 19.2594 17.4166 20.7286Z",
    fill: "#D1D5DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3159 20.5797C16.3159 20.8001 16.2496 20.9788 15.9182 20.9788C15.5868 20.9788 15.5205 20.8001 15.5205 20.5797C15.5205 20.3593 15.6531 20.1807 15.9182 20.1807C16.1833 20.1807 16.3159 20.3593 16.3159 20.5797Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4257 20.7286C21.4257 22.1979 22.3687 23.8097 23.6866 23.8097C25.0044 23.8097 27.1333 22.6125 27.1333 20.4178C27.1333 18.3561 24.8335 17.6228 22.457 17.9993C21.0005 18.2301 21.4257 19.2594 21.4257 20.7286Z",
    fill: "#D1D5DB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5283 20.5797C22.5283 20.8001 22.5946 20.9788 22.926 20.9788C23.2574 20.9788 23.3237 20.8001 23.3237 20.5797C23.3237 20.3593 23.1912 20.1807 22.926 20.1807C22.6609 20.1807 22.5283 20.3593 22.5283 20.5797Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7573 30.0002C27.7506 30.0002 33.6105 27.7474 33.6105 21.6868C33.6105 14.1049 27.7506 8.38525 19.7573 8.38525C11.764 8.38525 6.03662 14.637 6.03662 21.6868C6.03662 27.7474 11.764 30.0002 19.7573 30.0002ZM19.4427 27.6726C25.3224 27.6726 29.6328 26.0229 29.6328 21.5846C29.6328 16.0324 25.3224 11.8438 19.4427 11.8438C13.563 11.8438 9.35009 16.422 9.35009 21.5846C9.35009 26.0229 13.563 27.6726 19.4427 27.6726Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17257_545",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#9CA3AF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17257_545)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.5835,
    cy: 37.5,
    rx: 11.25,
    ry: 12.5,
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17257_545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.2d1a38adb4f0801fd4f4332ca12c6001.svg";
export { ForwardRef as ReactComponent };